export default {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  searchResults: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    createAdmin: {
      visible: false,
      admin: null,
    },
    enable: {
      visible: false,
      employee: null,
    },
    disable: {
      visible: false,
      admin: null,
    },
  },
  schema: null,
};
